import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientPaginationControls"] */ "/vercel/path0/packages/docs/src/app/playground/(demos)/pagination/pagination-controls.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderingControls"] */ "/vercel/path0/packages/docs/src/app/playground/(demos)/pagination/rendering-controls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/packages/docs/src/components/ui/separator.tsx");
